<template>
  <div class="props-display-container">
    <div class="props-header">
      <h3>Modal Props and Values</h3>
    </div>
    <div class="props-content">
      <pre class="props-json">{{ propsContent }}</pre>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PropsDisplayModal',
  props: {
    propsContent: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.props-display-container {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

.props-header {
  margin-bottom: 15px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 10px;
}

.props-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
}

.props-content {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 15px;
}

.props-json {
  font-family: 'Courier New', Courier, monospace;
  font-size: 12px;
  line-height: 1.4;
  color: #333;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0;
  background: transparent;
  border: none;
  max-width: 100%;
  overflow-x: auto;
}
</style>
